import { useEffect, useRef } from 'react';

/**
 * Store a value for access during the subsequent rerender
 *
 * @param {TValue} current Current value to store
 */
export const usePrevious = <TValue>(current: TValue) => {
  const previous = useRef(current);

  // Store current value as the previous one after the current rerender
  useEffect(() => {
    previous.current = current;
  }, [current, previous]);

  return previous.current;
};
